import React, { Component } from 'react';
import Transaction from './Transaction';

import './FeeVisualizer.css';

/* global _ */

const PRECISION_FEE_PERCENTAGE = 5;
const PRECISION_FEE_VALUE = 4;
const PRECISION_USD_PRICE_SMALL = 4;
const PRECISION_USD_PRICE = 2;
const MAX_TABLE_ROWS = 300;

const DUMMY_TRANSACTION_COUNT = 12;

class FeeVisualizer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            price: ''
        };
    }

    renderTransaction = (tx) => (<Transaction key={tx.id} id={tx.id} url={this.props.provider.getTransactionURL(tx.id)} amount={tx.amount} fee={tx.fee} amountUSD={tx.amountUSD} feeUSD={tx.feeUSD} percentage={tx.percentage} />);

    componentDidMount() {
        this.setState({ price: '' });
        this.props.provider.initialize();
        this.props.provider.getData(
            data => {
                this.setState({
                    price: data.price.toFixed(data.price < 10 ? PRECISION_USD_PRICE_SMALL : PRECISION_USD_PRICE) + ' USD',
                    allTransactions: data.transactions,
                    lastUpdated: data.lastUpdated
                });

                this.retrieveTransactions(+this.props.minAmount, +this.props.maxAmount);
            },
            () => {
                this.setState({ error: true });
            }
        );
    }

    retrieveTransactions(min, max) {
        let transactions = _.chain(this.state.allTransactions)
            .filter(tx => tx.fee > 0 && tx.amountUSD >= min && tx.amountUSD <= max)
            .take(MAX_TABLE_ROWS)
            .orderBy('percentage')
            .value();

        this.setState({
            error: undefined,
            price: this.state.price,
            allTransactions: this.state.allTransactions,
            transactions: transactions
        });
    }

    generateDummyTransactions() {
        const result = [];
        for (let i = 0; i < DUMMY_TRANSACTION_COUNT; i++) {
            result.push({
                id: "dummy_" + i,
                amount: NaN,
                fee: NaN,
                amountUSD: NaN,
                feeUSD: NaN,
                percentage: NaN
            });
        }
        return result;
    }

    renderTransactions = () => {
        const transactions = this.state.transactions || this.generateDummyTransactions();
        if (this.state.error) {
            return (<div className="text-danger">Error: cannot retrieve {this.props.provider.shortName} transactions.</div>);
        } else {
            return (
                <div>
                    <table className="table table-condensed">
                        <thead>
                            {
                                this.state.transactions
                                    ? (
                                        <tr>
                                            <td>Amount, USD</td>
                                            <td>Fee, USD</td>
                                            <td>Fee Percentage</td>
                                            <td></td>
                                        </tr>
                                    )
                                    : (
                                        <tr>
                                            <td>████ ███</td>
                                            <td>███ ███</td>
                                            <td>███ ██████</td>
                                            <td></td>
                                        </tr>
                                    )
                            }
                        </thead>
                        <tbody>{transactions.map(this.renderTransaction)}</tbody>
                    </table>
                </div>
            );
        }
    }

    renderAverageValues = () => {
        if (this.state.transactions) {
            if (this.state.transactions.length) {
                const average = {
                    percentage: _.meanBy(this.state.transactions, 'percentage').toFixed(PRECISION_FEE_PERCENTAGE),
                    feeUSD: _.meanBy(this.state.transactions, 'feeUSD').toFixed(PRECISION_FEE_VALUE)
                };
                const min = _.minBy(this.state.transactions, 'percentage'),
                    max = _.maxBy(this.state.transactions, 'percentage'),
                    // medianFee = (this.state.transactions[(this.state.transactions.length - 1) >> 1]['feeUSD'] + this.state.transactions[this.state.transactions.length >> 1]['feeUSD']) / 2,
                    medianPercentage = (this.state.transactions[(this.state.transactions.length - 1) >> 1]['percentage'] + this.state.transactions[this.state.transactions.length >> 1]['percentage']) / 2;

                return (
                    <div>
                        <b>
                            Average <span className="hidden-xs">transaction</span> fee is {average.percentage}%,
                                median <span className="hidden-xs">fee</span> is {medianPercentage.toFixed(PRECISION_FEE_PERCENTAGE)}%
                        </b>
                        <table className="table-fees"><tbody>
                            <tr>
                                <td>Min:</td>
                                <td>{min.feeUSD.toFixed(PRECISION_FEE_VALUE) + " USD"}</td>
                                <td>{min.percentage.toFixed(PRECISION_FEE_PERCENTAGE)}%</td>
                                <td>
                                    <a rel="noreferrer" target="_blank" href={this.props.provider.getTransactionURL(min.id)} className="btn btn-link btn-sm">
                                        Transaction Details
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>Max:</td>
                                <td>{max.feeUSD.toFixed(PRECISION_FEE_VALUE) + " USD"}</td>
                                <td>{max.percentage.toFixed(PRECISION_FEE_PERCENTAGE)}%</td>
                                <td>
                                    <a rel="noreferrer" target="_blank" href={this.props.provider.getTransactionURL(max.id)} className="btn btn-link btn-sm">
                                        Transaction Details
                                    </a>
                                </td>
                            </tr>
                        </tbody></table>
                        <p></p>
                        <p>Latest transactions with amount between {this.props.minAmount} and {this.props.maxAmount} USD:</p>
                    </div>
                );
            } else {
                return (
                    <p><i>No recent transactions with amount between {this.props.minAmount} and {this.props.maxAmount} USD found.</i></p>
                );
            }
        } else {
            return (
                <div className="animate-loading">
                    <b>
                        █████ <span className="hidden-xs">████████</span> ███ ██ █████,
                            █████ <span className="hidden-xs">███</span> ██ █████
                    </b>
                    <table className="table-fees"><tbody>
                        <tr>
                            <td>████</td>
                            <td>████ ███</td>
                            <td>████ ███</td>
                            <td>
                                <a rel="noreferrer" target="_blank" href="#" className="btn btn-link btn-sm">████████ █████</a>
                            </td>
                        </tr>
                        <tr>
                            <td>████</td>
                            <td>████ ███</td>
                            <td>████ ███</td>
                            <td>
                                <a rel="noreferrer" target="_blank" href="#" className="btn btn-link btn-sm">████████ █████</a>
                            </td>
                        </tr>
                    </tbody></table>
                    <p></p>
                    <p>████ ████████ ███ ████ ████ ██ ███ ██ ██</p>
                </div>
            );
        }
    }

    componentWillUpdate(nextProps, nextState) {
        if (nextProps.minAmount !== this.props.minAmount || nextProps.maxAmount !== this.props.maxAmount) {
            this.retrieveTransactions(nextProps.minAmount, nextProps.maxAmount);
        }
    }

    render() {
        const price = this.state.price || "█████ ███"
        return (
            <div>
                <h2>
                    <img src={`data:image/svg+xml;utf8,${this.props.provider.logoSVG}`} alt={this.props.provider.fullName} className="currency-logo" />
                    <b title={this.props.provider.fullName}>{this.props.provider.shortName}</b>
                    <span className={`price pull-right ${this.state.price ? "" : "animate-loading"}`} title={"Last updated: " + this.props.provider.lastUpdated}>{price}</span>
                </h2>
                {this.renderAverageValues()}
                <div className={`transactionsList ${this.state.price ? "" : "animate-loading"}`}>
                    {this.renderTransactions()}
                </div>
            </div>
        );
    }
}

export default FeeVisualizer;



// WEBPACK FOOTER //
// ./src/FeeVisualizer.js